import loginEntryDownload from 'BASE/components/downLoad/loginEntryDownload';

export default {
    mixins: [loginEntryDownload],
    props: {
        dialog: Object
    },
    data: function(){
        return {
            checkSettingComplete: true,
        };
    },
    methods: {
        showDownloadCenter(){
            let _dialog = this.$dialog.get('downloadcenter');
            _dialog.show();
        },
        closeDownloadCenter(){
            let _dialog = this.$dialog.get('downloadcenter');
            _dialog.hide();
        }
    }
}